import mixinMutations from '@/store/mixins/survey/editing/mutations'
import mixinActions from '@/store/mixins/survey/editing/actions'
import mixinGetters from '@/store/mixins/survey/editing/getters'
import mutations from './mutations'
import actions from './actions'
import segment from './segment'
import field from './field'
import option from './option'
import jump from './jump'
import preview from './preview'

export default {
	namespaced: true,
	state: {
		data: {},
		page_index: null,
		gap_open_index: null,
		focus_title: false,
		loading: false,
		locale: 'fi',
		target_types: [],
		//TODO remove 
		users: []
	},
	getters: {
		showing: state => state.data,
		loading: state => state.loading,
		targetTypes: state => state.target_types,
		users: state => state.users,
		...mixinGetters
  },
	mutations: {
		...mixinMutations,
		...mutations
	},
	actions: {
		...mixinActions,
		...actions
	},
	modules: {
		segment: segment,
		field: field, 
		option: option,
		jump: jump,
		preview: preview
	}
}

